import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", once = true, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-10% 0px" }}
    transition={{ duration: 0.9, delay, ease }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const LineReveal = ({ lines, className = "", delay = 0, as = "h2" }) => {
  const Tag = motion[as];
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span className="line-mask" key={i}>
          <motion.span
            className="block"
            initial={{ y: "110%", rotate: 2 }}
            whileInView={{ y: 0, rotate: 0 }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ duration: 1, delay: delay + i * 0.12, ease }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const SectionHead = ({ eyebrow, lines, text, align = "left" }) => (
  <div className={`mb-16 lg:mb-24 ${align === "right" ? "lg:ml-auto lg:text-right" : ""} max-w-3xl`}>
    <Reveal y={12}>
      <p className="eyebrow mb-6">{eyebrow}</p>
    </Reveal>
    <LineReveal
      lines={lines}
      className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.02] tracking-tight text-[var(--text)]"
    />
    {text && (
      <Reveal delay={0.3} y={16}>
        <p className="mt-8 text-base md:text-lg text-[var(--muted)] leading-relaxed max-w-xl">{text}</p>
      </Reveal>
    )}
  </div>
);
